import { css } from 'lit';

export const formControlStyles = css`
  :host {
    --tf-field-border: #cccccc;
    --tf-field-border-focus: #222222;
    --tf-field-border-error: #d0021b;
    --tf-field-text: #222222;
    --tf-field-text-muted: #767676;
    --tf-field-bg: #ffffff;
    --tf-field-bg-disabled: #f5f5f5;

    display: block;
    font-family: inherit;
    color: var(--tf-field-text);
  }

  :host([hidden]) {
    display: none;
  }

  .field {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .field__label {
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
    color: var(--tf-field-text);
  }

  .field__required-marker {
    color: var(--tf-field-border-error);
    margin-left: 2px;
  }

  .field__helper {
    font-size: 14px;
    line-height: 20px;
    color: var(--tf-field-text-muted);
  }

  .field__control-wrapper {
    position: relative;
    margin-top: 4px;
  }

  .field__control {
    box-sizing: border-box;
    width: 100%;
    min-height: 56px;
    padding: 16px;
    font: inherit;
    font-size: 16px;
    line-height: 24px;
    color: var(--tf-field-text);
    background: var(--tf-field-bg);
    border: 1px solid var(--tf-field-border);
    border-radius: 0;
    -webkit-appearance: none;
    outline: none;
  }

  .field__control:focus {
    border-color: var(--tf-field-border-focus);
  }

  .field__control::placeholder {
    color: var(--tf-field-text-muted);
  }

  :host([invalid]) .field__control {
    border-color: var(--tf-field-border-error);
    padding-right: 48px;
  }

  :host([disabled]) .field__control {
    background: var(--tf-field-bg-disabled);
    color: var(--tf-field-text-muted);
    cursor: not-allowed;
  }

  .field__error-icon {
    position: absolute;
    top: 16px;
    right: 16px;
    width: 24px;
    height: 24px;
    display: none;
    align-items: center;
    justify-content: center;
    color: var(--tf-field-border-error);
    font-weight: 700;
    pointer-events: none;
  }

  :host([invalid]) .field__error-icon {
    display: inline-flex;
  }

  .field__error {
    font-size: 14px;
    line-height: 20px;
    color: var(--tf-field-border-error);
    margin-top: 4px;
  }

  textarea.field__control {
    resize: vertical;
    min-height: 120px;
  }
`;
